import React from 'react';
import { lazy } from 'react-loosely-lazy';
import Blanket from '@atlaskit/blanket';
import Placeholder from '@atlassian/jira-placeholder';
import type IssueTypeSchemesType from './ui';
import type { Props } from './ui/types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NoLazyAsyncIssueTypeScheme = lazy<typeof IssueTypeSchemesType>(
	() => import(/* webpackChunkName: "async-issue-type-schemes-directory" */ './ui'),
);

export default function AsyncIssueTypeScheme(props: Props) {
	return (
		<Placeholder name="issue-type-scheme" fallback={<Blanket />}>
			<NoLazyAsyncIssueTypeScheme {...props} />
		</Placeholder>
	);
}
